const MONTHS_FULL = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'Novermber',
  'December'
];

const MONTHS_SHORT = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
];
const WEEKDAYS_FULL = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
];

const WEEKDAYS_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const decZero = (num) => (num < 10 ? `0${num}` : `${num}`);

const DATE_FORMAT_DICTIONARY = {
  YYYY: (date) => date.getFullYear(),
  YY: (date) => date.getFullYear().substr(-2, 2),
  MMMM: (date) => MONTHS_FULL[date.getMonth()],
  MMM: (date) => MONTHS_SHORT[date.getMonth()],
  MM: (date) => decZero(date.getMonth() + 1),
  M: (date) => date.getMonth() + 1,
  DD: (date) => decZero(date.getDate()),
  D: (date) => date.getDate(),
  dddd: (date) => WEEKDAYS_FULL[date.getDay()],
  ddd: (date) => WEEKDAYS_SHORT[date.getDay()],
  HH: (date) => decZero(date.getHours()),
  H: (date) => date.getHours(),
  hh: (date) => {
    /** Not sure */
    const hours = date.getHours();
    return decZero((hours > 12 ? hours - 12 : hours) + 1);
  },
  h: (date) => {
    /** Not sure */
    const hours = date.getHours();
    return (hours > 12 ? hours - 12 : hours) + 1;
  },
  mm: (date) => decZero(date.getMinutes()),
  m: (date) => date.getMinutes(),
  ss: (date) => decZero(date.getSeconds()),
  s: (date) => date.getSeconds(),
  Z: (date) => `${date.getTimezoneOffset() / 60}:00`
};

const DATE_FORMAT_REGEX = new RegExp(
  Object.keys(DATE_FORMAT_DICTIONARY).join('|'),
  'g'
);

/**
 * Robust date display option. It takes a string of tokens and replaces them with their corresponding values from a date given.
 * @param {Date} date date as a data source
 * @param {String} format format string
 */
export default function formatDate(date, format) {
  return format.replace(DATE_FORMAT_REGEX, (match) => {
    if (DATE_FORMAT_DICTIONARY[match]) {
      return DATE_FORMAT_DICTIONARY[match](date);
    }
    return match;
  });
}
